import React from "react";
import { GradientLoader } from "shared/components";
import Loaders from "../../../shared/components/Loaders";
import { Box, BoxTitle, BoxIcon, BoxValue } from "./Styles";

type SingleBoxPropT = {
  boxdata: {
    id: number;
    title: string;
    value?: any;
    icon?: string;
    background: boolean;
    urlPath?: string;
  };
  variant?: boolean;
  style?: Object;
  noPointer?: boolean;
  isLoading?: boolean;
  boxValueStyle?: Object;
  boxIconStyle?: Object;
  onClick?: () => any;
};

export default function SingleBox({
  boxdata,
  noPointer = false,
  variant,
  onClick,
  isLoading,
  style = {},
  boxValueStyle = {},
  boxIconStyle = {},
}: SingleBoxPropT) {
  return (
    <>
      <Box
        background={isLoading ? false : boxdata.background}
        style={{ cursor: !noPointer ? "pointer" : "default", ...style }}
        onClick={onClick}
      >
        {isLoading ? (
          <Loaders />
        ) : (
          <>
            {boxdata.icon && (
              <BoxIcon style={boxIconStyle} src={boxdata?.icon} />
            )}

            <BoxTitle>{boxdata?.title}</BoxTitle>
            <BoxValue style={boxValueStyle}>{boxdata?.value}</BoxValue>
          </>
        )}
      </Box>
    </>
  );
}
